// const QUACK = 'app/duck/QUACK';
const COMPLETED_CANCEL = 'supportersCancelScreen/COMPLETED_CANCEL';

const CANCEL_FETCH_START = 'supportersCancelScreen/CANCEL_FETCH_START';
const CANCEL_FETCH_SUCCEEDED = 'supportersCancelScreen/CANCEL_FETCH_SUCCEEDED';
const CANCEL_FETCH_FAILED = 'supportersCancelScreen/CANCEL_FETCH_FAILED';

const FETCH_STATION_ID_BEGIN = 'supportersCancelScreen/FETCH_STATION_ID_BEGIN';
const FETCH_STATION_ID_SUCCESS =
  'supportersCancelScreen/FETCH_STATION_ID_SUCCESS';
const FETCH_STATION_ID_FAILURE =
  'supportersCancelScreen/FETCH_STATION_ID_FAILURE';

const FETCH_PODCAST_METADATA_BEGIN =
  'supportersCancelScreen/FETCH_PODCAST_METADATA_BEGIN';
const FETCH_PODCAST_METADATA_SUCCESS =
  'supportersCancelScreen/FETCH_PODCAST_METADATA_SUCCESS';
const FETCH_PODCAST_METADATA_FAILURE =
  'supportersCancelScreen/FETCH_PODCAST_METADATA_FAILURE';

const SET_IS_PAGE_LOADING = 'supportersCancelScreen/SET_IS_PAGE_LOADING';

export default {
  COMPLETED_CANCEL,
  CANCEL_FETCH_START,
  CANCEL_FETCH_SUCCEEDED,
  CANCEL_FETCH_FAILED,
  FETCH_STATION_ID_BEGIN,
  FETCH_STATION_ID_SUCCESS,
  FETCH_STATION_ID_FAILURE,
  FETCH_PODCAST_METADATA_BEGIN,
  FETCH_PODCAST_METADATA_SUCCESS,
  FETCH_PODCAST_METADATA_FAILURE,
  SET_IS_PAGE_LOADING,
};
